module.exports = __webpack_public_path__ + "static/media/44.ad1a4d71.jpg";